import { useApiData } from '../useApiData';
import { setUser } from '../../store/user/actions';

export const useProfileApi = () => {
    useApiData('/me', setUser);
};
